var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 48,
    viewBox: "0 0 94 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8728 21.4061L67.8453 21.7431L68.4248 21.7112L69.1507 21.6792H69.5137V22.0511L69.4954 25.3658L69.4618 26.5104L69.4344 27.0885L70.1694 27.0711L70.9045 27.0885L70.8709 26.5104L70.8435 25.3658L70.8252 23.6837V21.6821H71.1881L71.9049 21.7141L72.4844 21.746L72.4661 21.409L72.4844 21.0633L71.7737 21.0895C71.1515 21.1156 70.6239 21.1301 70.1633 21.1301C69.7302 21.1301 69.1934 21.1127 68.5529 21.0895L67.8331 21.0633L67.8606 21.409L67.8728 21.4061ZM63.8132 26.6963L63.7705 27.1321L64.5422 27.074L65.6493 27.0653L66.6863 27.0972L67.275 27.1292L67.2567 26.7428L67.275 26.3477L66.6528 26.3884C66.299 26.4145 65.9696 26.4203 65.6737 26.4203L65.1705 26.4116V24.317L65.6889 24.3083C66.0611 24.317 66.3813 24.3345 66.668 24.3403L67.214 24.3809L67.1865 23.9946L67.214 23.5995L66.6955 23.6314C66.3752 23.6576 66.0458 23.6634 65.7103 23.6634L65.1735 23.6547V21.7576L65.6585 21.7664L66.7321 21.7983L67.278 21.8303L67.2597 21.4265L67.278 21.0459L66.7595 21.0866C66.4911 21.104 66.0489 21.1127 65.4358 21.1127C65.021 21.1127 64.7251 21.104 64.5452 21.0953L63.7736 21.0459L63.8163 21.4904L63.8406 22.2399V23.1724L63.8498 24.7557L63.8406 25.8509C63.8406 26.1734 63.8315 26.4523 63.8163 26.6847L63.8132 26.6963ZM59.9976 21.133C59.8604 21.133 59.7048 21.1156 59.6072 21.0924C58.8295 23.1521 57.9206 25.1072 57.03 27.1088C57.1428 27.0827 57.3075 27.0682 57.4448 27.0682C57.5912 27.0682 57.7833 27.0943 57.8779 27.1088C58.3811 25.6505 58.985 24.1979 59.6164 22.7396C60.1623 24.2066 60.8029 25.6505 61.2604 27.1088C61.4586 27.0827 61.7971 27.0682 62.0655 27.0682C62.3339 27.0682 62.6207 27.0856 62.8799 27.1088C62.032 25.1072 61.1932 23.1288 60.4124 21.0924C60.2752 21.1185 60.1349 21.133 59.9976 21.133Z",
    fill: "#7B1F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5789 16.3658L34.585 21.0226L29.2445 20.9181L34.5789 16.3658Z",
    fill: "#7B1F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5789 16.3658L30.919 15.901C32.0261 15.3375 33.2614 14.9714 34.5729 14.8523L34.579 16.363L34.5789 16.3658Z",
    fill: "#7B1F42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7759 15.3489V16.906L34.5789 16.3658L36.3237 14.8434C37.1777 14.9102 38.0012 15.0816 38.7759 15.346",
    fill: "#7B1F42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1919 17.3419L38.7698 16.9061L39.9165 15.8167C40.7492 16.2205 41.5148 16.7347 42.1888 17.339",
    fill: "#7B1F42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2566 16.97L29.2445 20.9181L26.3561 20.857C26.9569 19.3319 27.9665 17.9926 29.2536 16.97",
    fill: "#7B1F42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5852 21.0198L34.5761 25.6273L29.2538 26.1299L34.5852 21.0198Z",
    fill: "#7B1F42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5761 25.6273L34.5911 30.1969L29.22 31.2631L34.5761 25.6273Z",
    fill: "#7B1F42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2538 26.1299L29.2202 31.266C28.2534 30.4875 27.4421 29.5346 26.8504 28.4568L29.2538 26.1327L29.2538 26.1299Z",
    fill: "#7B1F42"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2538 26.1299L26.0358 26.4232C25.8406 25.6912 25.7369 24.9242 25.7369 24.134C25.7369 24.0527 25.7369 23.9713 25.7369 23.89L29.2414 20.9181L29.2505 26.1298L29.2538 26.1299Z",
    fill: "#7B1F42"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5911 30.1969L34.5911 33.41C33.795 33.3403 33.0234 33.1776 32.2944 32.9336L34.5911 30.1969Z",
    fill: "#7B1F42"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7576 21.0983L38.7515 25.2439L34.5761 25.6273L38.7576 21.0983Z",
    fill: "#7B1F42"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7729 16.9061L38.7576 21.0983L34.5852 21.0198L38.7729 16.9061Z",
    fill: "#7B1F42"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7574 29.3864V32.9249C37.7814 33.2531 36.7383 33.4362 35.6494 33.4536L38.7574 29.3894V29.3864Z",
    fill: "#7B1F42"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.207 30.9116C41.3317 31.7018 40.3008 32.338 39.1662 32.7767L42.2009 28.7154L42.207 30.9145V30.9116Z",
    fill: "#7B1F42"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7515 25.2439L38.7574 29.3864L34.5911 30.1969L38.7515 25.2439Z",
    fill: "#7B1F42"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1888 24.927L42.201 28.7123L38.7574 29.3864L42.1888 24.927Z",
    fill: "#7B1F42"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1734 21.1621L42.1888 24.927L38.7515 25.2439L42.1734 21.1621Z",
    fill: "#7B1F42"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2723 24.1311C45.2723 24.3025 45.2662 24.4739 45.257 24.6424L42.1888 24.927L44.8453 21.4033C45.1228 22.2661 45.2723 23.1841 45.2723 24.1341",
    fill: "#7B1F42"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.201 28.7123L45.2571 24.6511C45.1808 25.9555 44.827 27.1902 44.2445 28.2971L42.201 28.7123Z",
    fill: "#7B1F42"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1919 17.3419L42.1734 21.1621L38.7576 21.0983L42.1919 17.3419Z",
    fill: "#7B1F42"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7812 21.2028L42.1765 21.1621L43.8052 19.2128C44.2078 19.8316 44.5372 20.4968 44.7812 21.1999",
    fill: "#7B1F42"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2162 18.1262C79.3775 16.2001 78.1514 14.4658 76.6233 13.0132C73.5093 10.0471 69.3338 8.3999 64.9296 8.3999C58.7686 8.3999 53.12 11.6594 50.2652 16.8799C49.0421 19.1168 48.3955 21.6239 48.3955 24.1455C48.3955 27.1029 47.2975 29.8163 45.4675 31.937C42.9878 34.8073 39.3156 36.4283 35.4604 36.437C31.3948 36.4283 27.5823 34.5778 25.1514 31.4635C23.358 29.1656 22.5497 26.4987 22.6138 23.8841C22.7785 17.1675 28.5095 11.8686 35.5031 11.8686C37.7815 11.8686 39.9226 12.4322 41.78 13.4228C43.5277 14.3525 45.0283 15.6627 46.1537 17.2314C46.6448 16.0432 47.2609 14.9015 47.9899 13.8295C44.8392 10.3725 40.3038 8.40281 35.5001 8.40281C28.8328 8.40281 22.7998 12.223 20.2317 18.1146C19.4235 19.968 18.9751 22.0016 18.9721 24.131C18.9751 26.2605 19.4235 28.294 20.2287 30.1504C22.7754 36.01 28.7687 39.8825 35.4635 39.8999C39.8646 39.8883 44.0584 38.2295 47.1725 35.2692C48.7036 33.8166 49.9388 32.0823 50.7806 30.1562C51.5889 28.3056 52.0372 26.2808 52.0372 24.1543C52.0372 19.7821 54.4345 15.7847 58.3873 13.5652C60.3698 12.4525 62.6329 11.8715 64.9296 11.8715C67.9857 11.8715 70.7917 12.8854 73.003 14.579C76.1658 17.0019 77.7945 20.5229 77.8189 24.07C77.8708 30.9086 72.0575 36.4254 64.8899 36.4428C60.6596 36.4312 56.7098 34.4296 54.3064 31.1033C53.8184 32.2885 53.2084 33.4244 52.4856 34.4935C55.621 37.9215 60.1197 39.8883 64.8899 39.897C71.5725 39.8796 77.6024 36.0477 80.1857 30.2056C81.0458 28.2621 81.4698 26.182 81.4667 24.1049C81.4606 22.0713 81.0428 20.0348 80.2162 18.1291",
    fill: "#7B1F42"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1721 9.34987H12.5334V38.8628H16.1721V9.34987Z",
    fill: "#7B1F42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a34689f4d3bb3c08c8787de6f4901ba6.svg";
export { ForwardRef as ReactComponent };